import React from 'react';
import { Helmet } from 'react-helmet';
import './ParaSeuNegocio.css';
import ContactForm from '../components/ContactForm';
import logoPts from '../assets/intelbras/logo-pts.png';
import logoIntelbras from '../assets/intelbras/logo-intelbras.png';

// --- IMAGENS PARA A PÁGINA DE NEGÓCIOS ---
// Os nomes das imagens foram mantidos conforme seu código.
import heroBg from '../assets/banners/business-hero-bg.png';
import imgRestaurante from '../assets/intelbras/negocios/restaurante.png';
import imgMercado from '../assets/intelbras/negocios/mercado.png';
import imgLoja from '../assets/intelbras/negocios/loja.png';
import imgBarbearia from '../assets/intelbras/negocios/barbearia.png';
import imgAcademia from '../assets/intelbras/negocios/academia.png';
import imgClinica from '../assets/intelbras/negocios/clinica.png';

import solucaoPerimetral from '../assets/intelbras/negocios/solucao-perimetral.jpg';
import solucaoAcessoPessoas from '../assets/intelbras/negocios/solucao-acesso-pessoas.jpg';
import solucaoAcessoVeiculos from '../assets/intelbras/negocios/solucao-acesso-veiculos.jpg';
import solucaoMonitoramento from '../assets/intelbras/negocios/solucao-monitoramento.jpg';
import solucaoIncendio from '../assets/intelbras/negocios/solucao-incendio.jpg';
import solucaoRedes from '../assets/intelbras/negocios/solucao-redes.png';

// DADOS DOS CENÁRIOS DE NEGÓCIOS
const cenarios = [
    { id: 'restaurantes', nome: 'Restaurantes', imagem: imgRestaurante, texto: 'Monitore o acesso, faça a gestão dos estacionamentos, previna-se contra incêndios, tenha energia 100% autônoma e garanta a conectividade da sua equipe e clientes.' },
    { id: 'mercados', nome: 'Mercados', imagem: imgMercado, texto: 'Monitore todo o perímetro da loja, controle o acesso ao estoque e áreas restritas, tenha alarmes para prevenção de incêndio e mantenha a conectividade dos seus sistemas.' },
    { id: 'lojas', nome: 'Lojas', imagem: imgLoja, texto: 'Proteja sua loja e produtos. Monitore todas as áreas, controle quem acessa o estoque, tenha alarmes contra incêndio e mantenha todos os equipamentos funcionando com backup de energia.' },
    { id: 'barbearias', nome: 'Barbearias', imagem: imgBarbearia, texto: 'Monitore o salão e a recepção, controle o acesso à área de produtos, proteja seus equipamentos e ofereça conectividade de qualidade para seus clientes.' },
    { id: 'academias', nome: 'Academias', imagem: imgAcademia, texto: 'Controle o acesso, monitore a área de musculação e salas de aula, previna acidentes com alarmes de emergência e garanta conectividade para a equipe e alunos.' },
    { id: 'clinicas', nome: 'Clínicas Médicas', imagem: imgClinica, texto: 'Controle o acesso às salas, monitore a recepção, proteja equipamentos médicos com nobreaks e tenha uma conectividade estável para pacientes e sistemas de gestão.' },
];

// ESTRUTURA DE DADOS ATUALIZADA PARA AS SOLUÇÕES
const solucoes = [
    { 
        id: 'perimetral', 
        nome: 'Proteção Perimetral', 
        imagem: solucaoPerimetral,
        textoLongo: 'A proteção perimetral é a primeira e mais importante barreira de defesa para a segurança do seu patrimônio. Essencial para empresas, indústrias e condomínios, nossas soluções Intelbras são projetadas para inibir, detectar e alertar sobre qualquer tentativa de invasão. Implementamos sistemas que te ajudam a identificar invasores antes mesmo que eles se aproximem, protegendo áreas delimitadas com a mais alta tecnologia e adequando o projeto para qualquer necessidade, seja em muros, cercas ou grandes terrenos.',
        produtosExemplo: 'Exemplos: Centrais de alarme monitoradas, cercas elétricas industriais, sensores de barreira ativos (IVA), câmeras de segurança com Inteligência Artificial (IA) para detecção de intrusão e cerca virtual, câmeras térmicas para visibilidade noturna total, cancelas automáticas para controle de fluxo e integração com drones de monitoramento.',
        altText: 'Sistema de proteção perimetral com cercas elétricas industriais e sensores infravermelho instalados em muro de empresa.'
    },
    { 
        id: 'acesso-pessoas', 
        nome: 'Acesso e Gestão de Pessoas', 
        imagem: solucaoAcessoPessoas,
        textoLongo: 'A gestão eficiente de quem entra e sai é vital para a segurança e organização de qualquer negócio. O portfólio da Intelbras resolve os desafios diários, como o controle de acesso a áreas restritas, o gerenciamento de funcionários e visitantes, e a prevenção de acessos não autorizados. Oferecemos desde sistemas simples até soluções corporativas completas com software de gerenciamento, que permitem emitir relatórios detalhados e integrar com sistemas de ponto.',
        produtosExemplo: 'Exemplos: Controladores de acesso com biometria e reconhecimento facial, fechaduras digitais e eletrônicas para portas de vidro e madeira, catracas eletrônicas para recepções, videoporteiros IP com atendimento via app e software de gerenciamento de acesso.',
        altText: 'Funcionário utilizando biometria em um controlador de acesso facial Intelbras na entrada de um escritório.'
    },
    { 
        id: 'acesso-veiculos', 
        nome: 'Acesso e Gestão de Veículos', 
        imagem: solucaoAcessoVeiculos,
        textoLongo: 'Modernize a gestão de estacionamentos, pátios e garagens com o controle automatizado de entrada e saída de veículos. Com a precisão das inovações Intelbras, você diminui o risco de falhas na identificação, reduz filas, aumenta a segurança e facilita auditorias ou investigações em caso de incidentes. Crie uma experiência fluida para usuários autorizados e uma barreira segura contra acessos indevidos.',
        produtosExemplo: 'Exemplos: Câmeras com Leitura de Placas (LPR), cancelas automáticas de alto fluxo, antenas para leitura de TAGs veiculares, software para gestão de pátio e estacionamento, e Carregadores para Veículos Elétricos (CVE) para valorizar seu empreendimento.',
        altText: 'Cancelas automáticas com leitor de TAG veicular em estacionamento de um centro comercial.'
    },
    { 
        id: 'monitoramento', 
        nome: 'Central de Monitoramento', 
        imagem: solucaoMonitoramento,
        textoLongo: 'O monitoramento por CFTV é um fator determinante para a segurança e gestão do seu negócio. Oferecemos soluções completas para sua central, que vão desde câmeras com Inteligência Artificial para captação de imagens em alta resolução, dia e noite, até Nobreaks que garantem que todo o sistema de vigilância continue operando mesmo em quedas de energia. Tenha acesso remoto às imagens ao vivo ou gravadas, direto do seu celular.',
        produtosExemplo: 'Exemplos: Câmeras IP com infravermelho, gravadores de vídeo (NVRs), rádio comunicador, Video Wall para visualização centralizada, software de monitoramento VMS (Video Management System), switches PoE para alimentar as câmeras e Racks organizadores.',
        altText: 'Sala de monitoramento profissional com Video Wall exibindo imagens de múltiplas câmeras de segurança Intelbras.'
    },
    { 
        id: 'incendio', 
        nome: 'Prevenção de Incêndio', 
        imagem: solucaoIncendio,
        textoLongo: 'Garantir a segurança contra incêndios é uma obrigação legal e uma responsabilidade crucial. A Intelbras oferece soluções completas e certificadas para detecção e alarme, que garantem a conformidade com as normas do Corpo de Bombeiros (AVCB) e a proteção do seu patrimônio e, principalmente, de vidas. Nossos sistemas inteligentes permitem a detecção precoce de fumaça ou calor, acionando alertas imediatos para uma evacuação rápida e segura.',
        produtosExemplo: 'Exemplos: Centrais de alarme de incêndio endereçáveis e convencionais, detectores de fumaça e temperatura, acionadores manuais, sirenes audiovisuais e blocos autônomos para iluminação de emergência e sinalização de rota de fuga.',
        altText: 'Detector de fumaça Intelbras instalado no teto de um corredor corporativo, essencial para a prevenção de incêndio.'
    },
     { 
        id: 'redes', 
        nome: 'Conectividade e Redes', 
        imagem: solucaoRedes,
        textoLongo: 'Uma infraestrutura de rede robusta é a espinha dorsal de qualquer operação moderna. Oferecemos projetos de conectividade com Wi-Fi 6 de alta performance que não te deixam na mão, switches que organizam e distribuem o fluxo de dados de forma inteligente e toda a linha de cabeamento estruturado para garantir que sua equipe possa voar e seus clientes tenham a melhor experiência de conexão, seja em escritórios, lojas ou hotéis.',
        produtosExemplo: 'Exemplos: Roteadores Access Point corporativos (Wi-Fi 6), switches gerenciáveis com portas PoE para alimentar câmeras e telefones IP, roteadores com firewall para segurança da rede e soluções completas de cabeamento estruturado e fibra óptica.',
        altText: 'Access Point Wi-Fi 6 corporativo da Intelbras instalado no teto de uma empresa moderna, garantindo alta velocidade de conexão.'
    }
];


const ParaSeuNegocio = () => {
    // Função para rolagem suave
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <div className="page-negocio">
            <Helmet>
                <title>Soluções Empresariais de Segurança e Tecnologia | PTS & Intelbras</title>
                <meta name="description" content="Projetos completos de Segurança, Conectividade e Energia para empresas. CFTV, Controle de Acesso e mais. Surpreenda-se com nossa tecnologia." />
            </Helmet>

            {/* --- BLOCO 1: HERÓI --- */}
            <section className="negocio-hero" style={{ backgroundImage: `url(${heroBg})` }}>
                <div className="container">
                    <div className="negocio-hero-content">
                        <h1>Soluções de Segurança, Conectividade e Energia para o seu Negócio</h1>
                        <p>Surpreender é nossa tecnologia! Oferecemos soluções inovadoras para resolver o dia a dia e trazer mais eficiência à sua operação.</p>
                        <button onClick={() => scrollToSection('contato')} className="negocio-cta-button">
                            SOLICITE UMA PROPOSTA
                        </button>
                    </div>
                </div>
            </section>
            
            {/* --- BLOCO 2: CENÁRIOS DE APLICAÇÃO --- */}
            <section className="negocio-section negocio-cenarios">
                <div className="container">
                    <h2>Intelbras em todos os cenários</h2>
                    <p>Para cada negócio, uma solução sob medida. Acreditamos no poder dos pequenos e médios negócios brasileiros.</p>
                    <div className="cenarios-grid">
                        {cenarios.map(cenario => (
                            <div key={cenario.id} className="cenario-card">
                                <div className="cenario-imagem" style={{backgroundImage: `url(${cenario.imagem})`}}></div>
                                <div className="cenario-conteudo">
                                    <h3>{cenario.nome}</h3>
                                    <p>{cenario.texto}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* --- BLOCO 3: NOSSAS SOLUÇÕES (COM TEXTO LONGO E ALT TEXT) --- */}
            <section className="negocio-section negocio-solucoes-detalhadas">
                 <div className="container">
                    <h2>Nossas Soluções</h2>
                     <p>Usamos nossa experiência, tecnologia e olho no olho para aprimorar cada etapa da operação do seu negócio.</p>
                     <div className="solucoes-grid">
                        {solucoes.map(solucao => (
                            <div key={solucao.id} className="solucao-item">
                                <img src={solucao.imagem} alt={solucao.altText} className="solucao-imagem"/>
                                <div className="solucao-texto">
                                    <h3>{solucao.nome}</h3>
                                    <p className="solucao-texto-longo">{solucao.textoLongo}</p>
                                    <p className="solucao-produtos-exemplo">
                                        <strong>{solucao.produtosExemplo}</strong>
                                    </p>
                                    <button onClick={() => scrollToSection('contato')} className="solucao-interesse-btn">
                                        Tenho Interesse
                                    </button>
                                </div>
                            </div>
                        ))}
                     </div>
                </div>
            </section>

            {/* --- BLOCO 4: PARCERIA DE CONFIANÇA --- */}
            <section className="negocio-section negocio-autoridade">
                <div className="container">
                    <h2>Parceria de Confiança</h2>
                    <p>Unimos a liderança de mercado da Intelbras com a nossa excelência em instalação e configuração para entregar a melhor solução para sua empresa.</p>
                    <div className="logos-container">
                        <div className="logo-placeholder">
                            <img src={logoPts} alt="Logo Primo Trade Solutions" />
                        </div>
                        <div className="plus-icon">+</div>
                        <div className="logo-placeholder">
                            <img src={logoIntelbras} alt="Logo Intelbras" />
                        </div>
                    </div>
                </div>
            </section>

            {/* --- BLOCO 5: CHAMADA FINAL (CONVERSÃO) --- */}
            <section className="negocio-section negocio-final" id="contato">
                <div className="container">
                    <h2>Seu negócio está pronto para o próximo nível?</h2>
                    <p className="negocio-gatilho">
                        A demanda por empresas mais seguras e tecnológicas está em alta. Agende uma visita técnica sem compromisso. <strong>Nossas vagas para análise de projetos são limitadas</strong> para garantir a máxima atenção a cada cliente. Preencha o formulário e garanta a sua.
                    </p>
                    <div className="form-container-negocio">
                        <ContactForm />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ParaSeuNegocio;